/**
 * Gesundheitsportal - Users REST API
 * Gesundheitsportal Users Service REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: valeriu.craciun@kronsoft.ro
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Calendar display enum dto
 */
export type CalendarDisplayModeEnumDTO = 'DAILY' | 'WEEKLY' | 'MONTHLY';

export const CalendarDisplayModeEnumDTO = {
    DAILY: 'DAILY' as CalendarDisplayModeEnumDTO,
    WEEKLY: 'WEEKLY' as CalendarDisplayModeEnumDTO,
    MONTHLY: 'MONTHLY' as CalendarDisplayModeEnumDTO
};

